import { ContractTrackings } from "@/@client/Theasoft_ApiServer_Contracts"
import { ContractTrackingCard } from "@/components/contracts/ContractTrackingCard"
import { Modal, ModalProps } from "@mantine/core"

interface Props extends ModalProps {
  trackings: ContractTrackings[]
  trackingStartIndex: number
}

export function ContractTrackingModal({
  trackings,
  trackingStartIndex,
  ...modalProps
}: Props) {
  return (
    <Modal {...modalProps}>
      <ContractTrackingCard
        contractTrackings={trackings}
        trackingStartIndex={trackingStartIndex}
      />
    </Modal>
  )
}
